<template>
        <div>
            <h3 v-if="!this.isAddEquipmentMode" class="editor-header px-2">
                {{ $t('pipe_wire_cable.editor_title')  }}
            </h3>
            <location-deviation v-if="!this.isAddEquipmentMode" :location-deviation="item.location_deviation"/>
            <div class="px-2">
                <div v-if="!this.isAddEquipmentMode" class="row">
                    <div class="col-sm-6">
                        <span class="span-title">{{ $t('common.id') }}</span>
                        <span class="item-detail-text">{{ item.external_system_id }}</span>
                    </div>
                    <div class="col-sm-6">
                        <road-addess-view :road-number="item.road_num" :section-number="item.road_sec" :distance="item.distance" :show-street-name="false"/>
                    </div>
                </div>
               <div class="row">
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('drain.type') }}</span>
                       <select
                           v-model="item.type"
                           class="form-select form-select-sm"
                           :class="{'is-invalid': !validateIsNumber(item.type)}"
                       >
                           <option :value="null">{{ $t('pipe_wire_cable.select_type') }}</option>
                           <option
                               v-for="item in getPipeWireCableTypes()"
                               :key="item.value"
                               :value="item.value"
                           >
                               {{ item.name }}
                           </option>
                       </select>
                   </div>
                   <div class="col-sm-4">
                       <span class="span-title">{{ $t('drain.material') }}</span>
                       <select
                           v-model="item.material"
                           class="form-select form-select-sm"
                           :class="{'is-invalid': !validateIsNumber(item.material)}"
                       >
                           <option :value="null">{{ $t('materials.select_material') }}</option>
                           <option
                               v-for="item in getPipeWireCableMaterials()"
                               :key="item.value"
                               :value="item.value"
                           >
                               {{ item.name }}
                           </option>
                       </select>
                   </div>
                   <div class="col-sm-4">
                        <condition-selector v-model="item.condition"/>
                    </div>
                </div>
                <div class="row">
                    <location-details
                        v-if="!this.isAddEquipmentMode"
                        :lane-data="item.location_specification.lane"
                        :side-data="item.location_specification.side"
                        :track-data="item.location_specification.tracks"
                    />
                </div>
               <div class="row">
                       <div class="col-sm-4">
                           <span class="span-title">{{ $t('pipe_wire_cable.refined_materials.title') }}</span>
                           <select
                               v-model="item.refined_material"
                               class="form-select form-select-sm"
                           >
                               <option :value="null">
                                   {{ $t('pipe_wire_cable.select_refined_material') }}
                               </option>
                               <option
                                   v-for="item in getPipeWireCableRefinedMaterials()"
                                   :key="item.value"
                                   :value="item.value"
                               >
                                   {{ item.name }}
                               </option>
                           </select>
                       </div>
                       <div class="col-sm-4">
                           <span class="span-title">{{ $t('pipe_wire_cable.protective_tube') }}</span>
                           <div class="form-check form-check-sm">
                               <input
                                   id="protective_tube"
                                   type="checkbox"
                                   class="form-check-input"
                                   v-model="item.protective_tube"
                                   true-value="true"
                                   false-value="false"
                               />
                               <label class="form-check-label" for="protective_tube">
                                   {{ $t('pipe_wire_cable.protective_tube') }}
                               </label>
                           </div>
                       </div>
                       <div class="col-sm-4">
                           <span class="span-title">{{ $t('pipe_wire_cable.distance_from_road_edge') }}</span>
                           <input
                               id="distance_from_road_edge"
                               v-model="item.distance_from_road_edge"
                               type="number"
                               class="form-control form-control-sm"
                           />
                       </div>
                </div>
               <div class="row">
                       <div class="col-sm-4">
                           <span class="span-title">{{ $t('pipe_wire_cable.inside_diameter') }}</span>
                           <input
                               id="inside_diameter"
                               v-model="item.inside_diameter"
                               type="number"
                               class="form-control form-control-sm"
                               :class="{'is-invalid': !validateIsNumber(item.inside_diameter)}"
                           />
                       </div>
                       <div class="col-sm-4">
                           <span class="span-title">{{ $t('portal.code') }}</span>
                           <input
                               id="height"
                               min="1"
                               v-model="item.code"
                               type="text"
                               class="form-control form-control-sm"
                           />
                       </div>
                       <div class="col-sm-4">
                           <span class="span-title">{{ $t('pipe_wire_cable.length') }}</span>
                           <input
                               id="length"
                               v-model="item.length"
                               type="number"
                               class="form-control form-control-sm"
                               :class="{'is-invalid': !validateIsNumber(item.length)}"
                           />
                       </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('pipe_wire_cable.discharge_pipe') }}</span>
                        <div class="form-check">
                            <input
                                id="discharge_pipe"
                                class="form-check-input"
                                type="checkbox"
                                v-model="item.discharge_pipe"
                                true-value="true"
                                false-value="false"
                            />
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('pipe_wire_cable.overhead_structures') }}</span>
                        <div class="form-check">
                            <input
                                id="overhead_structures"
                                class="form-check-input"
                                type="checkbox"
                                v-model="item.overhead_structures"
                                true-value="true"
                                false-value="false"
                            />
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('pipe_wire_cable.strength_class') }}</span>
                        <input
                            id="strength_class"
                            v-model="item.strength_class"
                            type="text"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('pipe_wire_cable.underground_cable_structure') }}</span>
                        <div class="form-check">
                            <input
                                id="underground_cable_structure"
                                class="form-check-input"
                                type="checkbox"
                                v-model="item.underground_cable_structure"
                                true-value="true"
                                false-value="false"
                            />
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <span class="span-title">{{ $t('pipe_wire_cable.name') }}</span>
                        <input
                            id="name"
                            v-model="item.name"
                            type="text"
                            class="form-control form-control-sm"
                        />
                    </div>
                </div>
                <template v-if="this.isAddEquipmentMode">
                    <div class="row">
                        <div class="col-sm-4">
                            <span class="span-title">{{ $t('velho_equipment.starting_position') }}</span>
                        </div>
                        <div class="col-sm-12 nopads">
                            <h4 class="form-header nopads mt-0">{{ $t('velho_equipment.location_spesifications') }}</h4>
                            <velho-equipment-location-details-editor
                            :hideRampSelector="true"
                            :hideShoulderSelector="true"
                            :hidePlatformSelector="true"
                            :hideEdgeAreaSelector="true"
                            :hideDividerSelector="true"
                            :hideCenterAreaSelector="true"
                            :hideDitchBottomSelector="true"
                            :roadInfo="item"
                            :locationSpecification="item.location_specification"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">
                            <span class="span-title">{{ $t('velho_equipment.ending_position') }}</span>
                        </div>
                        <div class="col-sm-12 nopads">
                            <velho-equipment-location-details-editor
                            :hideRampSelector="true"
                            :hideShoulderSelector="true"
                            :hidePlatformSelector="true"
                            :hideEdgeAreaSelector="true"
                            :hideDividerSelector="true"
                            :hideCenterAreaSelector="true"
                            :hideDitchBottomSelector="true"
                            :roadInfo="item.location_ending"
                            :sideRequired="false"
                            :tracksRequired="false"
                            :hideSideSelector="true"
                            :hideTracksSelector="true"
                            />
                        </div>
                    </div>
                </template>
            <hr class="mb-0">
            <div class="row" v-if="this.isAddEquipmentMode">
                <div class="col-sm-6 nopads mt-2">
                    <equipment-date
                        :text="$t('velho_equipment.start_date')"
                        v-model="item.created_at"
                    />
                </div>
            </div>

            <div class="row">
                <equipment-actions v-if="!this.isAddEquipmentMode" ref="actions" v-model="item.actions" />
            </div>
            <div class="row">
                <linked-equipment
                    v-if="item.linked_equipment && item.linked_equipment.length > 0"
                    :linked-equipments="item.linked_equipment"
                />
            </div>
            </div>
            <velho-editor-buttons
                v-if="!this.isAddEquipmentMode"
                :url="extPipesWiresCablesUrl"
                :selected-contract="selectedContract"
                :item="item"
                :disabled="loading"
                @close="close"
                @submit="handleSubmit"
                @removalConfirmed="removalConfirmed"
            />
        <div
            v-if="loading > 0"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {mapHelper} from "@/components/mixins/MapMixin";
import {conversionModelHelper} from "@/components/mixins/ConversionMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import ConditionSelector from "@/components/velho/ConditionSelector";
import {velhoHelper} from "@/components/mixins/VelhoMixin";
import EquipmentActions from "@/components/velho/EquipmentActions";
import {pipeWireCableHelper} from "@/components/mixins/PipeWireCableMixin";
import VelhoEditorButtons from "@/components/velho/VelhoEditorButtons";
import LinkedEquipment from "@/components/velho/LinkedEquipment";
import LocationDetails from "@/components/velho/LocationDetails.vue";
import LocationDeviation from "@/components/velho/LocationDeviation";
import VelhoEquipmentLocationDetailsEditor from "@/components/velho/VelhoEquipmentLocationDetailsEditor";
import RoadAddessView from "@/components/velho/RoadAddressView";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";

export default {
    name: 'PipesWiresCablesEditor',
    components: {
        EquipmentDate,
        RoadAddessView,
        LocationDeviation,
        LocationDetails, VelhoEditorButtons, EquipmentActions, ConditionSelector, LinkedEquipment, VelhoEquipmentLocationDetailsEditor},
    mixins: [mapHelper, conversionModelHelper, restApi, velhoHelper, pipeWireCableHelper, velhoValidationMixin],
    props: {
        item: {
            type: Object,
            default: null
        },
        selectedContract: {
            type: Object,
            default: null
        },
        addEquipmentEditor: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        isAddEquipmentMode() {
            return this.addEquipmentMode
        }
    },
    data() {
        return {
            addEquipmentMode: this.addEquipmentEditor,
            map: null,
            loading: false,
        }
    },
    methods: {
        handleSubmit: function(url, item, selectedContract, replace = false) {
            if(replace) {
                this.submitEquipmentsreplace(this.extEquipmentsReplaceUrl, [item], selectedContract)
            } else {
                this.submitEquipment(url, item, selectedContract);
            }
        },
        close: function () {
            this.$emit('close')
        },
        isValidForm: function() {
            if(!this.validateRoadNumber(this.item.road_num)) { return false }
            if(!this.validateRoadSection(this.item.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.distance)) { return false }
            if(!this.validateRoadSide(this.item.location_specification.side)) { return false }
            if(!this.validateRoadTracks(this.item.location_specification.tracks)) { return false }
            if(!this.validateRoadNumber(this.item.location_ending.road_num)) { return false }
            if(!this.validateRoadSection(this.item.location_ending.road_sec)) { return false }
            if(!this.validateRoadDistance(this.item.location_ending.distance)) { return false }
            if(!this.validateIsNumber(this.item.type)) { return false }
            if(!this.validateIsNumber(this.item.material)) { return false }
            if(!this.validateIsNumber(this.item.inside_diameter)) { return false }
            if(!this.validateIsNumber(this.item.length)) { return false }

            return true
        }
    }
}
</script>

<style scoped>
</style>

